import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { styledHeaderText } from "../../styled";
import { DialogContextType } from "../../DialogComponents/FullScreenDialog";
import { styledHeaderSubTitle } from "../components/styledHeaderSubTitle";
import { useUploadDataContext } from "../uploadDataContext";
import { useLayerItem } from "../../../../modules/LayerList/hooks/useLayerItem";
import { useDialogInfo } from "../../../../hooks/useDialogs";

export const useContext = (): DialogContextType => {
  const { resources } = useDialogInfo();
  const layerItem = useLayerItem(resources[0]);
  const { step, uploadedFiles } = useUploadDataContext();
  const { t } = useTranslation();

  return useMemo(
    () => ({
      title: {
        text: styledHeaderText(t("uploadData.dialogHeader", { ns: "dialogs" })),
        icon: "upload",
      },
      applyText: t("actions.ready", { ns: "common" }),
      subTitle: styledHeaderSubTitle({
        layerName: layerItem.layer.alias,
        uploadedFiles,
        step,
        toLayer: t("uploadData.toLayer", { ns: "dialogs" }),
        and: t("uploadData.and", { ns: "dialogs" }),
      }),
    }),
    [layerItem.layer.alias, step, t, uploadedFiles],
  );
};
